export enum PaymentStatus {
  Success = 'success',
  Cancel = 'cancel',
}
